<template>
  <div class="container-fluid" id="about">
    <Navigation></Navigation>
    <div class="row wrapper">
      <div class="col-12 col-md-4 side-banner">
        <div class="header">
          <!-- <div id="steps" class="steps" tabindex="0" role="document">
            <span>Step 1</span> of 7
          </div> -->
          <div class="company-logo"></div>
          <h1 tabindex="0">About you</h1>
          <div class="hero-image" alt="About you"></div>
        </div>
      </div>

      <div class="col-12 col-md-8 main-banner">
        <div class="main">
          <ValidationObserver v-slot="{ valid }" ref="form">
            <form @submit.prevent="onSubmit" @keydown.enter="$event.preventDefault()">
              <div class="form-group">
                <ValidationProvider mode="lazy" name="age" :rules="'required:'+pageContent.pages.about.outOfRangeErrorMessage+'|between:'+config.fields.age.min+','+config.fields.age.max+','+pageContent.pages.about.outOfRangeErrorMessage" v-slot="{ errors, failedRules }">
                  <label for="age" tabindex="0">Your age</label>
                  <cleave
                    ref="age"
                    data-analytics-capture-value="true"
                    :options="formatOptions.age"
                    class="form-control"
                    id="age"
                    name="age"
                    v-model.number="data.stepData.age"
                    type="text"
                    tabindex="0"
                    v-on:blur="updateAgeRelatedFieldValues"
                    @keydown.native.enter.prevent="$refs.gender.focus()">
                  </cleave>
                  <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>
                  <span v-if="failedRules.between && pageContent.pages.about.infoBoxError" v-html="pageContent.pages.about.infoBoxError"></span>
                  <span v-if="data.stepData.age >= 67 && data.stepData.age < 74 && pageContent.pages.about.infoBoxErrorIP" v-html="pageContent.pages.about.infoBoxErrorIP"></span>
                  <span v-if="data.stepData.age == 74 && pageContent.pages.about.infoBoxErrorIPTPD" v-html="pageContent.pages.about.infoBoxErrorIPTPD"></span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider name="gender" :rules="'required:'+pageContent.pages.about.genderRequiredErrorMessage" v-slot="{ errors }">
                  <div class="row no-gutters">
                    <div class="col-auto"><label tabindex="0">Your sex at birth</label></div>
                    <div class="col-auto">
                      <b-button id="tooltip-gender" variant="tooltip" aria-label="tooltip gender"><i class="icon-help mb-0"></i></b-button>
                      <b-tooltip target="tooltip-gender" placement="top">
                        {{pageContent.pages.about.tooltipGender}}
                      </b-tooltip>
                      <!-- todo -->
                    </div>
                  </div>
                  <select ref="gender" id="gender" class="form-control"
                    v-model="data.stepData.gender" tabindex="0" aria-label="gender" @change="triggerHeightCheck()"
                    @keydown.enter.prevent="$refs[`familyType${data.stepData.familyType ? data.stepData.familyType : 'Single'}`].focus()">
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                  <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-group max">
                <ValidationProvider name="coupledep" :rules="'required:'+pageContent.pages.about.familyTypeRequiredErrorMessage" v-slot="{ errors }">
                  <label tabindex="0">Your family</label><br>
                  <div class="row no-gutters square-button-row">
                      <div class="col-12 col-lg-6">
                        <div class="btn-radio-square">
                          <input ref="familyTypeSingle" tabindex="0" type="radio" id="single" name="familyType" v-model="data.stepData.familyType" :value="Enum.familyType.SINGLE" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                          <label for="single">
                            <i class="icon single"></i>
                            <span>Single</span>
                          </label>
                        </div>

                        <div class="btn-radio-square">
                          <input ref="familyTypeCouple" tabindex="0" type="radio" id="couple" name="familyType" v-model="data.stepData.familyType" :value="Enum.familyType.COUPLE" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                          <label for="couple">
                            <i class="icon couple"></i>
                            <span>Couple</span>
                          </label>
                        </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <div class="btn-radio-square">
                          <input ref="familyTypeSingle_Dependant" tabindex="0" type="radio" id="singledep" name="familyType" v-model="data.stepData.familyType" :value="Enum.familyType.SINGLE_DEPENDANT" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                          <label for="singledep">
                            <i class="icon single-dependant"></i>
                            <span>Single with dependant(s)</span>
                          </label>
                        </div>

                        <div class="btn-radio-square">
                          <input ref="familyTypeCouple_Dependant" tabindex="0" type="radio" id="coupledep" name="familyType" v-model="data.stepData.familyType" :value="Enum.familyType.COUPLE_DEPENDANT" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                          <label for="coupledep">
                            <i class="icon couple-dependant"></i>
                            <span>Couple with dependant(s)</span>
                          </label>
                        </div>
                      </div>
                  </div>
                  <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="info-box" v-if="data.stepData.familyType === Enum.familyType.SINGLE">
                <div class="form-row">
                  <div class="col-1 icon"><i class="icon-info"></i></div>
                  <div class="col text">{{pageContent.pages.about.familyTypeSingle}}</div>
                </div>
              </div>
              <div class="info-box" v-if="data.stepData.familyType === Enum.familyType.COUPLE">
                <div class="form-row">
                  <div class="col-1 icon"><i class="icon-info"></i></div>
                  <div class="col text">{{pageContent.pages.about.familyTypeCouple}}</div>
                </div>
              </div>
              <div class="info-box" v-if="data.stepData.familyType === Enum.familyType.SINGLE_DEPENDANT">
                <div class="form-row">
                  <div class="col-1 icon"><i class="icon-info"></i></div>
                  <div class="col text">{{pageContent.pages.about.familyTypeCouple}}</div>
                </div>
              </div>
              <div class="info-box" v-if="data.stepData.familyType === Enum.familyType.COUPLE_DEPENDANT">
                <div class="form-row">
                  <div class="col-1 icon"><i class="icon-info"></i></div>
                  <div class="col text">{{pageContent.pages.about.familyTypeCouple}}</div>
                </div>
              </div>

              <!-- dependants -->
              <div class="form-group" v-if="data.stepData.familyType === Enum.familyType.SINGLE_DEPENDANT || data.stepData.familyType === Enum.familyType.COUPLE_DEPENDANT">
                <div class="row no-gutters">
                  <div class="col-auto"><h2 tabindex="0">Your dependants</h2></div>
                  <div class="col-auto">
                    <b-button id="tooltip-dependants" variant="tooltip" aria-label="tooltip dependants"><i class="icon-help"></i></b-button>
                    <b-tooltip target="tooltip-dependants" placement="top">
                      People aged 18 or younger who financially depend on you.
                    </b-tooltip>
                  </div>

                </div>
                <div class="row repeat-input" v-for="(dependant, ind) in dependants" :key="ind">
                  <div class="col">
                    <div class="row">
                      <div class="col"><label :for="'dependant_'+ind" tabindex="0">Age of dependant {{ind + 1}}</label></div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <ValidationProvider mode="lazy" :name="'dependant_'+ind" :rules="'required:'+pageContent.pages.about.dependantAgeRangeErrorMessage+'|between:'+config.fields.dependantsAge.min+','+config.fields.dependantsAge.max+','+pageContent.pages.about.dependantAgeRangeErrorMessage" v-slot="{ errors }">
                          <cleave
                            data-analytics-capture-value="true"
                            tabindex="0"
                            :options="formatOptions.age"
                            class="form-control pre-remove-btn"
                            :id="'dependant_'+ind"
                            v-model.number="dependant.Age"
                            :value="dependant.Age"
                            v-on:blur="triggerHeightCheck"
                            type="text">
                          </cleave>
                          <button tabindex="0" v-if="ind != 0" type="button" class="remove-item-btn" v-on:click="removeDependant(ind)"><i class="icon-remove" aria-label="Remove dependant"></i></button>
                          <br/><span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }" v-html="errors[0]"></span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="info-box" v-if="dependants.length === 5">
                      <div class="form-row">
                        <div class="col-1 icon"><i class="icon-info"></i></div>
                        <div class="col text" v-html="pageContent.pages.about.dependantLimitInfoMessage"></div>
                      </div>
                    </div>
                    <button class="add-button" tabindex="0" type="button" v-on:click="addDependant" v-if="dependants.length < 5">+ Add dependant</button>
                  </div>
                </div>
              </div>
              <!-- end debts -->

              <div class="nav-button row" >
                <router-link class="assumption-button col" :to="{ name: 'Assumptions', params: {activeTab: 'assumptions' } }" tabindex="0" role="button"><i class="icon-edit"></i> Edit assumptions </router-link>
                <router-link class="back-button col" :to="{ name: 'Intro', params: {choice: 'about' } }" tabindex="0" role="button">Back </router-link>
                <button class="next-button col" v-bind:class="[valid ? 'is-active' : 'is-disabled']"  type="submit" tabindex="0" role="button">Next</button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>

    </div>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapFields } from "vuex-map-fields";
import Cleave from "vue-cleave-component";

import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required, between } from 'vee-validate/dist/rules';
import CustomFooter from '../components/CustomFooter';
import Navigation from "../components/Navigation.vue";

import _ from 'lodash';

extend('required', {
  ...required,
  params: ['msg'],
  message: '{msg}'
});
extend('between', {
  ...between,
  params: ['min', 'max', 'msg'],
  validate(value, { min, max }) {
    return value >= min && value <= max;
  },
  message: '{msg}'
});

export default {
  name: 'About',
  components: { Cleave, ValidationProvider, ValidationObserver, CustomFooter, Navigation },
  computed: {
    ...mapFields(["data", "dependants", "prevTab"]),
    ...mapGetters(["Enum", "config", "formatOptions", "pageContent"]),
  },
  methods: {
    toggleFamilyTypeBtn() {
      this.triggerHeightCheck();
    },
    addDependant() {
      this.dependants.push({"Age": null, "Amount": 3000, "Error": false});
      this.triggerHeightCheck();
    },
    removeDependant(ind) {
      if(this.dependants.length > 1) {
        this.dependants.splice(ind, 1);
      }
      else {
        this.dependants.pop();
        this.dependants.push({"Age": null, "Amount": 3000, "Error": false});
      }
      this.triggerHeightCheck();
    },
    updateAgeRelatedFieldValues: function() {
      this.$store.commit("updateAgeRelatedFieldValues");
			this.$store.commit("setLifeInsurancePaymentPeriod");
      this.triggerHeightCheck();
		},
    triggerHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
    onSubmit () {
      this.$refs.form.validateWithInfo().then(result => {
        if (!result.isValid) {
          var fieldArr = _.valuesIn(result.fields);
          var firstError = document.getElementById(fieldArr[0].id)
          if(firstError) {
            firstError.scrollIntoView({behavior: 'smooth'});
          }
          this.triggerHeightCheck();
          return;
        }
        this.prevTab = 1;
        this.$router.push('/debt');
      });
    },
    updateRouteName: function() {
      this.$store.commit("updateRouteName");
		},
  },
  mounted() {
    //load defaults
    this.triggerHeightCheck();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },
  beforeDestroy() {
    // send analytics - complete form step
    var dataObj = {
      "age": this.data.stepData.age,
      "gender": this.data.stepData.gender,
      "familyType": this.data.stepData.familyType,
      "dependants": []
    };
    if(this.data.stepData.familyType === this.Enum.familyType.SINGLE_DEPENDANT ||
       this.data.stepData.familyType === this.Enum.familyType.COUPLE_DEPENDANT) {
         this.dependants.forEach(dependant => {
           var dep = {"Age": dependant.Age}
           dataObj.dependants.push(dep);
         });
    }
    this.$gtag.event('step-about', { event_category: 'form-step-progress', event_label: JSON.stringify(dataObj) });

    // clear any dependant errors when moving step. should not be any errors.
    // Was showing error on expenses page or if you went to next step and back to about step.
    this.dependants.forEach(dep => {
      dep.Error = false;
    });
  }
};
</script>
